import { AlarmTypeGroup } from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import { TrashIcon } from '@heroicons/react/24/solid';

interface AlarmTypeGroupMembersProps {
  alarmTypeGroup: AlarmTypeGroup;
  onRemoveAlarmType: (alarmTypeId: string) => () => void;
  deleteDisabled: boolean;
}

export function AlarmTypeGroupMembers(props: AlarmTypeGroupMembersProps) {
  const { alarmTypeGroup, onRemoveAlarmType, deleteDisabled } = props;
  const alarmTypes = alarmTypeGroup.alarmTypes || [];

  return (
    <div className="p-4 text-xs">
      {alarmTypes.map((alarmType) => (
        <div
          key={alarmType.alarmTypeId}
          className="m-2 inline-flex w-48 items-center justify-center gap-2 rounded-xl border-2 p-2 dark:border-gray-600"
        >
          <span
            title={alarmType.name}
            className="overflow-hidden overflow-ellipsis whitespace-nowrap"
          >
            {alarmType.name}
          </span>
          <Button
            variant="icon"
            onClick={onRemoveAlarmType(alarmType.alarmTypeId)}
            title="Remove alarm type from alarm type group"
            disabled={deleteDisabled}
            loading={deleteDisabled}
          >
            <TrashIcon className="h-4 w-4 hover:text-red-500" />
          </Button>
        </div>
      ))}
      {alarmTypes.length === 0 && (
        <div className="text-center text-gray-600 dark:text-gray-400">
          No alarm types attached to this alarm type group
        </div>
      )}
    </div>
  );
}
